import AbstractAxiosService from './AbstractAxiosService'
import { config } from '@/config'

export default class ShopmanagerService extends AbstractAxiosService {
	constructor(options = {}) {
		super(options)
		this.accumulatorCancelGroups.push("orderSubmit")
		this.headersNoCache = {
			'Cache-Control': 'no-cache',
			'Pragma': 'no-cache',
			'Expires': '0',
		}
	}

	products({ slug = "", channel = config.DEFAULT_CHANNEL, token = "", page = 1, limit = 199, locale = config.LOCALE, accumulatorGroup = null }) {
		const params = { channel, locale, limit, page };

		if (token) {
			params.token = token;
		}

		return this.makeRequest("get", '/shop-api/taxon-products/by-code/:slug', {
			group: accumulatorGroup,
			path: { slug },
			params,
		})
	}

	highlightProducts({ slug = config.DEFAULT_TAXON_HIGHLIGHT_PRODUCTS, channel = config.DEFAULT_CHANNEL, token = "", page = 1, limit = 199, locale = config.LOCALE, accumulatorGroup = null }) {
		const params = { channel, locale, limit, page, onlyHighlightProducts: 1 };

		if (token) {
			params.token = token;
		}

		return this.makeRequest("get", '/shop-api/taxon-products/by-code/:slug', {
			group: accumulatorGroup,
			path: { slug },
			params,
		})
	}

	taxons({ channel = config.DEFAULT_CHANNEL, entrypoint, token, locale = config.LOCALE, accumulatorGroup = null }) {
		const params = { locale, channel };

		if (token) {
			params.token = token;
		}

		return this.makeRequest("get", '/shop-api/taxons/:entrypoint', { group: accumulatorGroup, path: { entrypoint }, params })
	}

	/*
	 * CART
	*/
	carts({ channel, zip, shippingCode, orderNow, deliverTime = null, deliverTimeslot = null, campaignId = null, oldToken = null, referralToken = null, locale = config.LOCALE }) { //we force the channel
		const data = { zip, shippingCode, orderNow, oldToken, referralToken }
		if (deliverTime != null) {
			data.deliverTime = deliverTime
		}
		if (deliverTimeslot != null) {
			data.deliverTimeslot = deliverTimeslot
		}
		if (campaignId != null) {
			data.campaignId = campaignId
		}
		return this.makeRequest("post", '/shop-api/carts', data, { params: { channel, locale } })
	}

	cart({ token, channel, recalculate = false, locale = config.LOCALE, accumulatorGroup = null }) {
		return this.makeRequest("get", '/shop-api/carts/:token', { path: { token }, params: { channel, locale, recalculate }, group: accumulatorGroup })
	}

	addCartItems({ token, items, channel, locale = config.LOCALE, accumulatorGroup }) {
		/* item = {
			quantity,
			productCode,
			[variantCode]
		}
		*/
		return this.makeRequest("post", '/shop-api/carts/:token/multiple-items', { items }, { path: { token }, params: { channel, locale }, group: accumulatorGroup })
	}

	updateCartItem({ token, identifier, quantity, channel, locale = config.LOCALE, accumulatorGroup }) {
		return this.makeRequest("put", '/shop-api/carts/:token/items/:identifier', { quantity }, { path: { token, identifier }, params: { channel, locale }, group: accumulatorGroup })
	}

	removeCartItem({ token, identifier, channel, locale = config.LOCALE, accumulatorGroup }) {
		return this.makeRequest("delete", '/shop-api/carts/:token/items/:identifier', { path: { token, identifier }, params: { channel, locale }, group: accumulatorGroup })
	}

	replaceCartItemChildren({ token, identifier, childCodes, locale = config.LOCALE }) {
		return this.makeRequest("put", '/shop-api/carts/:token/items/:identifier/products', { childCodes }, { path: { token, identifier }, params: { locale } })
	}

	addCoupon({ token, coupon, email, channel, locale = config.LOCALE }) {
		return this.makeRequest("put", '/shop-api/carts/:token/coupon', { coupon, email }, { path: { token }, params: { channel, locale } })
	}

	removeCoupon({ token, channel, locale = config.LOCALE }) {
		return this.makeRequest("delete", '/shop-api/carts/:token/coupon', { path: { token }, params: { channel, locale } })
	}

	updateDeliverTime({ orderNow, deliverTime, deliverTimeslot, deliverMethod, productCode, confirmChange = false, token, channel, locale = config.LOCALE }) {
		return this.makeRequest("put", '/shop-api/carts/:token/delivertime', { orderNow, deliverTime, deliverTimeslot, deliverMethod, productCode, confirmChange }, { path: { token }, params: { channel, locale } })
	}

	resetAdditinoalProducts({ token, channel, locale = config.LOCALE, accumulatorGroup }) {
		return this.makeRequest("put", '/shop-api/carts/:token/reset-additional-products', { resetAdditionalProductsModified: true }, { path: { token }, params: { channel, locale }, group: accumulatorGroup })
	}

	/*
	 * CHECKOUT
	*/
	checkoutSummary({ token, channel, locale = config.LOCALE, accumulatorGroup = null }) {
		return this.makeRequest("get", '/shop-api/checkout/:token', { path: { token }, params: { channel, locale }, group: accumulatorGroup })
	}

	checkoutAddressChange({ token, shippingAddress, billingAddress, email, channel, locale = config.LOCALE, accumulatorGroup = null }) {
		return this.makeRequest("put", '/shop-api/checkout/:token/address', { shippingAddress, billingAddress, email }, { path: { token }, params: { channel, locale }, group: accumulatorGroup })
	}

	checkoutPayments({ token, channel, locale = config.LOCALE, accumulatorGroup = null }) {
		return this.makeRequest("get", '/shop-api/checkout/:token/payment', { path: { token }, params: { channel, locale }, group: accumulatorGroup })
	}

	checkoutPaymentChange({ token, method, channel, locale = config.LOCALE, accumulatorGroup = null }) {
		return this.makeRequest("put", '/shop-api/checkout/:token/payment/:id', { method }, { path: { token, id: 0 }, params: { channel, locale }, group: accumulatorGroup })
	}

	checkoutShippings({ token, channel, locale = config.LOCALE, accumulatorGroup = null }) {
		return this.makeRequest("get", '/shop-api/checkout/:token/shipping', { path: { token }, params: { channel, locale }, group: accumulatorGroup })
	}

	checkoutShippingChange({ token, street, streetNumber, city, zip, locale = config.LOCALE, accumulatorGroup = null }) {
		return this.makeRequest("put", '/shop-api/checkout/:token/shipping', { street, streetNumber, city, zip }, { path: { token }, params: { locale }, group: accumulatorGroup })
	}

	checkoutSubmit({ token, email, notes, channel, tip, confirmedAlcohol, dropoffType, newsletter, birthday, chopsticks, locale = config.LOCALE, accumulatorGroup = null }) {
		return this.makeRequest(
			"put",
			'/shop-api/checkout/:token/complete',
			{ email, notes, confirmedAlcohol, dropoffType, tip, newsletter, birthday, chopsticks },
			{ path: { token }, params: { channel, locale }, group: accumulatorGroup }
		)
	}

	addressAutocomplete({ street, streetNumber, postcode, limit = 20, locale = config.LOCALE, accumulatorGroup = null } = {}) {
		const params = {
			limit,
			locale
		}

		if (street) {
			params.street = street
		}

		if (streetNumber) {
			params.streetNumber = streetNumber
			params.houseNumber = streetNumber // legacy param
		}

		if (postcode) {
			params.postcode = postcode
		}

		return this.makeRequest("get", '/shop-api/post/address-autocomplete', { params, group: accumulatorGroup })
	}

	/*
	 * ORDER
	*/
	orderShow({ token, channel, locale = config.LOCALE, accumulatorGroup = null }) {
		return this.makeRequest("get", '/shop-api/orders/:token', { path: { token }, params: { channel, locale }, group: accumulatorGroup })
	}

	orderRestore({ token, channel, oldToken, locale = config.LOCALE, accumulatorGroup = null }) {
		return this.makeRequest("get", '/shop-api/restore/:token', { path: { token }, params: { channel, locale, oldToken }, group: accumulatorGroup })
	}

	/*
	 * LOCATION
	*/
	locationQuery({ zip, brand, deliveryMethod, locale = config.LOCALE }) {
		return this.makeRequest("get", '/shop-api/zip/find/:brand/:method/:zip', { path: { zip, brand, method: deliveryMethod }, params: { locale } })
	}
	locations({ brand, locale = config.LOCALE }) {
		return this.makeRequest("get", '/shop-api/channel/:brand', { path: { brand }, params: { locale }, headers: { ...this.headersNoCache } })
	}

	/*
	 * Account
	*/

	brands({ locale = config.LOCALE, accumulatorGroup }) {
		return this.makeRequest("get", "/shop-api/customer/active-brands", { params: { locale }, group: accumulatorGroup })
	}

	login({ email, password, brand, locale = config.LOCALE, accumulatorGroup = null }) {
		return this.makeRequest("post", '/shop-api/login', { email, password, brand }, { params: { locale }, group: accumulatorGroup })
	}

	me({ brand, token, locale = config.LOCALE, accumulatorGroup = null }) {
		return this.makeRequest("get", '/shop-api/me', { group: accumulatorGroup, params: { brand, locale }, headers: { 'Authorization': `Bearer ${token}` } })
	}

	accountUpdateMe({ brand, token, userDetail, locale = config.LOCALE, accumulatorGroup = null }) {
		return this.makeRequest("put", '/shop-api/me', userDetail, { group: accumulatorGroup, params: { brand, locale }, headers: { 'Authorization': `Bearer ${token}` } })
	}

	accountClaimCoupon({ code, token, locale = config.LOCALE, accumulatorGroup }) {
		return this.makeRequest("post", "/shop-api/customer/claim-coupon", { code }, { params: { locale }, group: accumulatorGroup, headers: { 'Authorization': `Bearer ${token}` } })
	}

	accountOrders({ token, channel, shippingCode = null, brand = config.BRAND, limit = 10, locale = config.LOCALE, accumulatorGroup = null }) {
		const params = { brand, limit, locale }
		if (channel) {
			params.channel = channel
		}
		if (shippingCode) {
			params.shippingCode = shippingCode
		}
		return this.makeRequest("get", '/shop-api/orders', { group: accumulatorGroup, params, headers: { 'Authorization': `Bearer ${token}` } })
	}

	accountFavoriteProducts({ token, cartToken, channel, locale = config.LOCALE, accumulatorGroup = null }) {
		return this.makeRequest("get", '/shop-api/me/products', { group: accumulatorGroup, params: { token: cartToken, channel, locale }, headers: { 'Authorization': `Bearer ${token}` } })
	}

	accountRegister({ email, password, birthday, brand, userGroup = null, userCoupon = null, checkTerms, registerConfirmUrl = "", firstName = "empty", lastName = "empty", phoneNumber = "", recaptchaResponse, locale = config.LOCALE }) {
		return this.makeRequest("post", '/shop-api/register', { email, registerConfirmUrl, plainPassword: password, birthday, firstName, lastName, phoneNumber, brand, userGroup, userCoupon, checkTerms, recaptchaResponse }, { params: { locale } })
	}

	accountRequestPasswordReset({ email, passwordResetUrl, brand, locale = config.LOCALE }) {
		return this.makeRequest("put", "/shop-api/request-password-reset", { email, passwordResetUrl, brand }, { params: { locale } })
	}

	accountResetPassword({ password, confirm, token, brand, locale = config.LOCALE }) {
		return this.makeRequest("put", "/shop-api/password-reset/:token", { password: { first: password, second: confirm } }, { path: { token }, params: { locale, brand } })
	}

	accountChangePassword({ current, password, confirm, token, locale = config.LOCALE }) {
		return this.makeRequest("put", "/shop-api/me/change-password", { currentPassword: current, newPassword: { first: password, second: confirm } }, { params: { locale }, headers: { 'Authorization': `Bearer ${token}` } } )
	}

	accountAddresses({ token, locale = config.LOCALE, accumulatorGroup }) {
		return this.makeRequest("get", "/shop-api/address-book/", { params: { locale }, group: accumulatorGroup, headers: { 'Authorization': `Bearer ${token}` } })
	}

	accountLastAddress({ brand, token, locale = config.LOCALE, accumulatorGroup }) {
		return this.makeRequest("get", "/shop-api/customer/last-address", { params: { brand, locale }, group: accumulatorGroup, headers: { 'Authorization': `Bearer ${token}` } })
	}

	accountUpdateAddress({ userAddress, token, locale = config.LOCALE, accumulatorGroup }) {
		return this.makeRequest("post", "/shop-api/customer/update-address", userAddress, { params: { locale }, group: accumulatorGroup, headers: { 'Authorization': `Bearer ${token}` } })
	}

	accountPoinzRegister({ brand, birthday, gender, token, locale = config.LOCALE, accumulatorGroup }) {
		return this.makeRequest("post", "/shop-api/poinz/register", { brand, birthday, gender }, { params: { locale }, group: accumulatorGroup, headers: { 'Authorization': `Bearer ${token}` } })
	}

	accountPoinzRedeem({ brand, token, locale = config.LOCALE, accumulatorGroup }) {
		return this.makeRequest("post", "/shop-api/poinz/redeem", { brand }, { params: { locale }, group: accumulatorGroup, headers: { 'Authorization': `Bearer ${token}` } })
	}

	accountGetQRToken({ token, locale = config.LOCALE }) {
		return this.makeRequest("get", "/shop-api/qr-token/token", { params: { locale }, headers: { 'Authorization': `Bearer ${token}` } })
	}

	accountLoginWithQR({ token, locale = config.LOCALE, accumulatorGroup }) {
		return this.makeRequest("post", '/shop-api/qr-token/qr2jwt', { token }, { params: { locale }, group: accumulatorGroup })
	}

	migrationBrands({ email, locale = config.LOCALE, accumulatorGroup }) {
		return this.makeRequest("post", "/shop-api/customer/migrate-brands", { email }, { params: { locale }, group: accumulatorGroup })
	}

	migrationStart({ email, brand, checkTerms, migrateVerifyUrl, locale = config.LOCALE, accumulatorGroup }) {
		return this.makeRequest("post", "/shop-api/customer/migrate", { email, brand, checkTerms, migrateVerifyUrl }, { params: { locale }, group: accumulatorGroup })
	}

	migrationVerify({ email, token, brand, locale = config.LOCALE, accumulatorGroup }) {
		return this.makeRequest("post", "/shop-api/customer/migrate-verify-email", { email, token, brand }, { params: { locale }, group: accumulatorGroup })
	}

	subscribeNewsletter({ email, firstname, lastname, recaptchaResponse, brand, locale = config.LOCALE, accumulatorGroup }) {
		return this.makeRequest("post", "/shop-api/mailchimp", { email, firstname, lastname, recaptchaResponse, brand }, { params: { locale }, group: accumulatorGroup })
	}

	// RESERVATION
	reservationChannelList({ brand, locale = config.LOCALE, accumulatorGroup = null }) {
		return this.makeRequest("get", "/shop-api/locations/with-reservation/:brand", { params: { locale }, group: accumulatorGroup, path: { brand } })
	}

	// SELFORDERING
	selforderingInit({ channel, deliverTime = null, orderNow = null, locale = config.LOCALE }) {
		const params = { channel, locale }
		if (deliverTime) {
			params.deliverTime = deliverTime
			params.orderNow = orderNow
		}
		return this.makeRequest('get', '/self-ordering-api/v1/init', { params })
	}

	selforderingValidateCoupon({ code, channel, deliverTime = null, orderNow = null, locale = config.LOCALE }) {
		const data = { couponCode: code }
		if (deliverTime) {
			data.deliverTime = deliverTime
			data.orderNow = orderNow
		}
		return this.makeRequest('post', '/self-ordering-api/v1/validate-coupon', data, { params: { channel, locale } })
	}

	selforderingCreateOrder({ order, channel, locale = config.LOCALE }) {
		return this.makeRequest('post', '/self-ordering-api/v1/create-order', { ...order }, { params: { channel, locale } })
	}

	// FEATURE_PLANZER_DELIVERY
	planzerDeliveryDates({ zip, locale = config.LOCALE }) {
		return this.makeRequest("get", '/shop-api/planzer/delivery-dates/:zip', { path: { zip }, params: { locale } })
	}

	// ABANDONED CART
	abandonOptout({ token, locale = config.LOCALE }) {
		return this.makeRequest("get", '/shop-api/abandoned-cart-email/opt-out/:token', { path: { token }, params: { locale } })
	}
}
